export const PanelRightOpenIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            {...props}
        >
            <rect width={18} height={18} x={3} y={3} rx={2} />
            <path d="M15 3v18M10 15l-3-3 3-3" />
        </svg>
    );
};
